const SKIP_REDIRECT_PATHS_REGEX = [
  /^\/blog/, // matches /blog, /blog/abc, /blog/article-123, etc.
  /^\/features/, // matches /features, /features-x, /features/abc, etc.
  /^\/mutual-funds\/[a-z0-9-]+-\d+$/, // matches /mutual-funds/abc-123, /mutual-funds/xyz-456, etc.
  /^\/calculators(\/.*)?$/, // matches /calculators and /calculators/abc, /calculators/xyz, etc.
  /^\/us-stocks\/[a-z0-9-]+-share-price-[a-z]+$/i, // matches /us-stocks/abc-share-price-xyz, /us-stocks/xyz-share-price-abc, etc.
  /^\/stocks\/[a-z0-9-]+-share-price-[a-z]+$/i, // matches /stocks/abc-share-price-xyz, /stocks/xyz-share-price-abc, etc.
]

export const shouldSkipAuthRedirect = (pathname: string) =>
  SKIP_REDIRECT_PATHS_REGEX.some(pattern => pattern.test(pathname))
